/**
 * Phone field constants (MYN-277, FR-184). Dial codes come from `libphonenumber-js`
 * (`min` metadata), never from the geography API's `phonecode` column.
 */

/** E.164 allows 15 digits in total; the national part can never exceed that. */
export const PHONE_MAX_NATIONAL_DIGITS = 15;

export const PHONE_E164_PREFIX = '+';

export const PHONE_STRINGS = {
  /** Shown when a required phone is left empty (partner profile, public application). */
  REQUIRED: 'Phone is required',
  /** Plain-language refusal for a number that is not valid for the chosen country. */
  INVALID: 'Enter a valid phone number for the selected country',
  COUNTRY_PICKER_LABEL: 'Country code',
  COUNTRY_PICKER_PLACEHOLDER: 'Search country or code',
  NUMBER_PLACEHOLDER: 'Phone number',
  /** Prefix of the note that keeps a legacy free-text value visible beside the field. */
  LEGACY_NOTE: 'Saved earlier as',
  LEGACY_REMOVE: 'Remove',
  LEGACY_REMOVE_LABEL: 'Remove the phone saved earlier',
} as const;
